<template>
	<div class="ac-top">
		<div class="ac-title" :class="tips?'':'long'">{{title}}</div>
		<div class="ac-tips" :class="red?'red':''">{{tips}}</div>
	</div>
</template>
<script>
export default {
	props: {
		title:{
			type: String,
			default:'标题'
		},
		tips:{
			type: String,
			default:''
		},
		red: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			
		}
	},
	created () {
	},
	methods: {
		
	}
}
</script>
<style lang="less" scoped>
.ac-top{
	display: flex;
	align-items: center;
	.ac-title{
		font-size: 14px;
		font-weight: bold;
		margin-left: 12px;
		line-height: 20px;
		width:120px;
		position: relative;
		padding: 10px 0;
	}
	.ac-title.long{
		width:100%;
	}
	.ac-title::before{
		content: '';
		width: 5px;
		height: 15px;
		background: #2d8cf0;
		position: absolute;
		top: 12px;
		left: -12px;
	}
	.ac-tips{
		flex:1;
		font-size: 12px;
		line-height: 20px;
		margin: 10px 0;
		margin-right: 40px;
	}
	.ac-tips.red{
		color: #ed4014;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/agent/AgentTitle.vue